import React, { useEffect } from 'react'

export default function PreSave() {
    useEffect(() => {
        window.location.href = 'https://open.spotify.com/prerelease/235PpDAgaWkEUunfesiuW2'
    }, [])
    return (
        <div></div>
    )
}